import { ReactNode } from "react";
import { imgPhonePhone } from "@/shared/assets/img";

type Props = {
  children: ReactNode;
};

export default function PhoneWrapper({ children }: Props) {
  return (
    <div
      id="phone"
      className="relative flex justify-center items-center w-[22.625rem] h-[46.875rem] pt-3 pb-2.5 px-3 rounded-4 overflow-hidden"
      style={{
        backgroundImage: `url(${imgPhonePhone})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
    >
      {children}
    </div>
  );
}
